import type { AppProps } from "next/app";
import "@JohnLewisPartnership/core-page-assets/dist/prod/static/core/css/jlp-styles-2.css";

export default function App({ Component, pageProps }: AppProps) {
  return <Component {...pageProps} />;
}
